export const GOT_MIN_ALLOWED_AGE_ACTION = {
    name: 'GOT_MIN_ALLOWED_AGE_ACTION',
    action: (minAllowedAgeCR, minAllowedAgeTC) => ({
        minAllowedAgeCR, minAllowedAgeTC,
        type: GOT_MIN_ALLOWED_AGE_ACTION.name
    })
};

export const GOT_MIN_ALLOWED_VEHICLE_PRICE_ACTION = {
    name: 'GOT_MIN_ALLOWED_VEHICLE_PRICE_ACTION',
    action: (minAllowedVehiclePriceCR, minAllowedVehiclePriceTC) => ({
        minAllowedVehiclePriceCR, minAllowedVehiclePriceTC,
        type: GOT_MIN_ALLOWED_VEHICLE_PRICE_ACTION.name
    })
};

export const GOT_MIN_DOWN_PAYMENT_ACTION = {
    name: 'GOT_MIN_DOWN_PAYMENT_ACTION',
    action: (minDownPaymentCR, minDownPaymentTC) => ({
        minDownPaymentCR, minDownPaymentTC,
        type: GOT_MIN_DOWN_PAYMENT_ACTION.name
    })
};

export const GOT_MAX_DOWN_PAYMENT_ACTION = {
    name: 'GOT_MAX_DOWN_PAYMENT_ACTION',
    action: (maxDownPaymentCR, maxDownPaymentTC) => ({
        maxDownPaymentCR, maxDownPaymentTC,
        type: GOT_MAX_DOWN_PAYMENT_ACTION.name
    })
};

export const GOT_SMS_TIMER_RESEND_ACTION = {
    name: 'GOT_SMS_TIMER_RESEND_ACTION',
    action: smsTimerResend => ({
        smsTimerResend,
        type: GOT_SMS_TIMER_RESEND_ACTION.name
    })
};

export const GOT_PRICE_AND_DOWN_PAYMENT_ACTION = {
    name: 'GOT_PRICE_AND_DOWN_PAYMENT_ACTION',
    action: (minAllowVehiclePrice: number, minDownPayment: number, maxDownPayment: number) => ({
        minAllowVehiclePrice, minDownPayment, maxDownPayment,
        type: GOT_PRICE_AND_DOWN_PAYMENT_ACTION.name
    })
};